import Image from 'next/image';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { WHITE_LABEL_LOGO } from '../lib/white-label';
import { analytics } from '../lib/analytics';

const MaintenanceWrapper = styled.div`
  text-align: center;
  height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  h1 {
    font-size: 3rem;
    font-weight: 900;
  }
`;

const Maintenance = () => {
  useEffect(() => {
    analytics.page('Maintenance');
  }, []);
  return (
    <MaintenanceWrapper>
      <Image alt="" width={200} height={200} src={WHITE_LABEL_LOGO} />
      <h1>UNDER MAINTENANCE</h1>
      <p>We will be right back! </p>
      <p>
        We are currently pushing an update to increase your user experience!
      </p>
      <br />
      <p>
        If you have any questions feel free to open a ticket with our live chat
        at the bottom right of your screen
      </p>
    </MaintenanceWrapper>
  );
};

export default Maintenance;
